module.exports = __webpack_public_path__ + "static/media/logo4.15fdb439.png";